import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tooltip-container" }
const _hoisted_2 = { class: "tooltip-container" }
const _hoisted_3 = { class: "tooltip-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "default_card large mx-0 my-2 pa-2",
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "d-flex justify-start align-center pb-2"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("h2", null, "Paramètres cabinet pour ce dossier", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "d-flex pr-2 px-2",
            cols: "3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_select_filled, {
                  ref: "signatoryAccountantElement",
                  modelValue: _ctx.signatoryId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signatoryId) = $event)),
                  items: _ctx.users,
                  "item-value": "value",
                  label: _ctx.$t('settings.signatoryAccountant'),
                  density: "compact",
                  "item-title": (item) => item.key,
                  style: {"height":"20px"},
                  clearable: "",
                  "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.signatoryId = null)),
                  disabled: _ctx.auditReportMode
                }, null, 8, ["modelValue", "items", "label", "item-title", "disabled"]),
                (_ctx.$refs.signatoryAccountantElement)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      activator: "parent"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString((_ctx.$refs.signatoryAccountantElement as VSelect).label), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pr-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_oss_date_picker_filled, {
                  ref: "startProductionDateElement",
                  modelValue: _ctx.startProductionDate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startProductionDate) = $event)),
                  label: "Date de début",
                  style: {"flex":"1"},
                  textFieldReadOnly: false,
                  mandatory: false,
                  disabled: _ctx.auditReportMode
                }, null, 8, ["modelValue", "disabled"]),
                (_ctx.$refs.startProductionDateElement)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      activator: "parent"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString((_ctx.$refs.startProductionDateElement as OssDatePicker).label), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pr-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_oss_date_picker_filled, {
                  ref: "endProductionDateElement",
                  modelValue: _ctx.endProductionDate,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endProductionDate) = $event)),
                  label: "Date de fin",
                  style: {"flex":"1"},
                  textFieldReadOnly: false,
                  mandatory: false,
                  disabled: _ctx.auditReportMode
                }, null, 8, ["modelValue", "disabled"]),
                (_ctx.$refs.endProductionDateElement)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      activator: "parent"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString((_ctx.$refs.endProductionDateElement as OssDatePicker).label), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}